import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { type Config, type Cta, TokenHistoryLabel } from "kadow-jetpack-model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleXmark,
  faExternalLinkSquare
} from "@fortawesome/free-solid-svg-icons";
import React, { type ChangeEvent, useMemo } from "react";
import { Field, type FormikErrors } from "formik";
import { type Socials } from "kadow-jetpack-model";
import {
  KADOW_COLOR_NEGATIVE,
  KADOW_COLOR_POSITIVE
} from "../../../../../utils/constants";
import KC_Span from "../../../../../designsystem/KC_Span/KC_Span";
import KC_Colors from "../../../../../designsystem/KC_Colors";
import { rebuildSocialLink } from "../../../../../utils/helpers/rebuildSocialLink";
import { displaySocialLink } from "../../../../../utils/helpers/displaySocialLink";
import { getPlaceholder } from "../../../../17_JetpackOnboarding/components/helpers/getPlaceholder";

interface Props {
  cta: Cta;
  idx: number;
  ctaTagValue: string | undefined;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  config: Config;
  errors: FormikErrors<Config>;
}

export default function SocialCtaField(props: Props) {
  const goToSocialLink = (link: string) => {
    window.open(link, "_blank");
  };

  const socialFieldId = useMemo(() => {
    return getSocialField(props.cta.id);
  }, [props.cta]);

  return (
    <>
      <div className="d-flex kc-input-wrapper flex-grow-1">
        <span className="input-group-prepend p-2 border-right bg-shaded d-none d-sm-block">
          <KC_UIText weight={"bold"} text={displaySocialLink(props.cta.id)} />
        </span>
        <Field
          className="kc_input p-2"
          placeholder={getPlaceholder(props.cta.id)}
          id={`socials-${getSocialField(props.cta.id)}`}
          type="text"
          name={`socials.${getSocialField(props.cta.id)}`}
          htmlFor={`socials.${getSocialField(props.cta.id)}`}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            props.setFieldValue(
              `socials.${getSocialField(props.cta.id)}`,
              e.target.value
            );
          }}
          disabled={props.cta.id === TokenHistoryLabel.Google}
          required={true}
        />

        <div className="input-group-append p-2">
          {props.config.socials?.[
            getSocialField(props.cta.id) as keyof Socials
          ] ? (
            <FontAwesomeIcon
              icon={faCircleCheck}
              color={KADOW_COLOR_POSITIVE}
              size={"lg"}
            />
          ) : (
            <FontAwesomeIcon
              icon={faCircleXmark}
              color={KADOW_COLOR_NEGATIVE}
              size={"lg"}
            />
          )}
        </div>

        <div className="input-group-append p-2 border-left h-100 cursor-pointer">
          <div
            onClick={() => {
              goToSocialLink(
                rebuildSocialLink(
                  props.cta.id,
                  props.config.socials?.[
                    getSocialField(props.cta.id) as keyof Socials
                  ] || ""
                )
              );
            }}
          >
            <FontAwesomeIcon
              icon={faExternalLinkSquare}
              color={"#FF2C81"}
              size={"lg"}
            />
          </div>
        </div>
      </div>

      {!!socialFieldId && props.errors?.socials?.[socialFieldId] && (
        <KC_Span
          id="error"
          className="error"
          text={socialFieldId && props.errors?.socials?.[socialFieldId]}
          color={KC_Colors.Error}
        />
      )}
    </>
  );
}

const getSocialField = (ctaId: string): keyof Socials | null => {
  switch (ctaId) {
    case TokenHistoryLabel.Instagram:
    case TokenHistoryLabel.IGStory:
      return "instagram";

    case TokenHistoryLabel.Facebook:
      return "facebook";

    case TokenHistoryLabel.TikTok:
      return "tiktok";

    case TokenHistoryLabel.SnapChat:
      return "snapchat";

    default:
      return null;
  }
};
